"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var BarHor_1 = __importDefault(require("atomicComponents/atoms/Graphs/BarHor"));
var EstimateBar_1 = __importDefault(require("atomicComponents/atoms/Graphs/EstimateBar"));
var BarHorTitle_1 = __importDefault(require("atomicComponents/organisms/Text/BarHorTitle"));
var Money_1 = __importDefault(require("components/Money"));
var BarContainer_1 = __importDefault(require("containers/SaaSAudit/Savings/styles/BarContainer"));
var Text_1 = __importDefault(require("shared/components/Text"));
var SCALES = [20, 525, 2000, 8000];
var getScale = function (max, maxWidth) {
    var e_1, _a;
    try {
        for (var SCALES_1 = __values(SCALES), SCALES_1_1 = SCALES_1.next(); !SCALES_1_1.done; SCALES_1_1 = SCALES_1.next()) {
            var amountPerPx = SCALES_1_1.value;
            if (max / amountPerPx < maxWidth)
                return amountPerPx;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (SCALES_1_1 && !SCALES_1_1.done && (_a = SCALES_1.return)) _a.call(SCALES_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return max / maxWidth;
};
var BenchmarkGraph = function (_a) {
    var amount = _a.amount, benchmark = _a.benchmark, label = _a.label, _b = _a.barGraphColor, barGraphColor = _b === void 0 ? 'neutral' : _b;
    var min = benchmark.min, max = benchmark.max;
    var amountPerPx = getScale(max, 625);
    var getPixelScale = function (amt) { return amt / amountPerPx; };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ alignItems: "center", width: 175 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, noWrap: true }, { children: label })) })), (0, jsx_runtime_1.jsxs)(BarContainer_1.default, __assign({ width: 625 }, { children: [(0, jsx_runtime_1.jsx)(BarHor_1.default, __assign({ width: getPixelScale(amount), size: "regular", color: barGraphColor, roundedCornerRight: true }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: amount, isShortened: "NEW" }) })), (0, jsx_runtime_1.jsx)(BarHorTitle_1.default, { posX: getPixelScale(max), width: 110, value: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: min, isShortened: "NEW" }), "-", (0, jsx_runtime_1.jsx)(Money_1.default, { amount: max, isShortened: "NEW" })] }) }), (0, jsx_runtime_1.jsx)(EstimateBar_1.default, { width: getPixelScale(max - min), size: "regular", position: getPixelScale(min) })] }))] })));
};
exports.default = BenchmarkGraph;
